export const AppRoutePaths = {
  index: '/',
  academic_terms: {
    create: '/academic_terms/create',
    view: '/academic_terms/view',
  },
  auth: {
    login: '/login',
    twofa: '/twofa',
    forgot_password: {
      enter_email: '/forgot_password/enter_email',
      check_email: '/forgot_password/check_email',
    },
    reset_password: '/reset_password',
    sign_up: '/sign_up',
  },
  dashboard: {
    index: '/dashboard',
  },
  not_access: {
    index: '/not_access',
  },
  family_applications: {
    index: '/family_applications',
    student_details: {
      index: '/student_details',
      basic_info: '/basic_info',
      ssn: '/ssn',
      scholarships: '/scholarships',
      scholarships_warning: '/scholarships_warning',
      public_or_charter_school: '/public_or_charter_school',
      lea: '/lea',
      lea_warning: '/lea_warning',
      birth_certificate: {
        index: '/birth_certificate',
        y: {
          index: '/y',
          capture_instructions: '/capture_instructions',
          capture: '/capture',
          photo_review: '/photo_review',
          photo_submitted: '/photo_submitted',
        },
        n: {
          index: '/n',
          enter_brith_date: '/enter_brith_date',
          confirm_brith_date: '/confirm_brith_date',
          additional_details_required_warning:
            '/additional_details_required_warning',
        },
        additional_student: '/additional_student',
      },
      income_verification: {
        index: '/income_verification',
        skip: {
          index: '/skip',
          skip_confirmation: '/skip_confirmation',
        },
        household_size: '/household_size',
        household_income: '/household_income',
        household_single_dual: '/household_single_dual',
        tax_document: {
          index: '/tax_document',
          form_1040: {
            index: '/form_1040',
            doc_example: '/doc_example',
            instructions: '/instructions',
            capture: '/capture',
            capture_review: '/capture_review',
          },
          form_w2: {
            index: '/form_2s',
            doc_example: '/doc_example',
            instructions: '/instructions',
            capture: '/capture',
            capture_review: '/capture_review',
          },
          form_1099: {
            index: '/form_1099',
            doc_example: '/doc_example',
            instructions: '/instructions',
            capture: '/capture',
            capture_review: '/capture_review',
          },
          submit_document: '/submit_document',
        },
      },
    },
  },
  applicants: {
    index: '/applicants',
    pre_selected: {
      index: '/applicants/pre_selected',
    },
    lottery: {
      index: '/applicants/lottery',
    },
    selected: {
      index: '/applicants/selected',
    },
    notifications: {
      index: '/applicants/notifications',
    },
    applicant_details: {
      application: '/applicants/:applicantId/details',
      appeals: '/applicants/:applicantId/appeals',
      history: '/applicants/:applicantId/history',
      chat: '/applicants/:applicantId/chat',
      documents: '/applicants/:applicantId/documents',
      payments: '/applicants/:applicantId/payments',
    },
  },
  tasks: {
    index: '/tasks',
    queue: '/tasks/next_up_queue',
    review: '/tasks/review',
    chat: '/tasks/chat',
    documents: '/tasks/next_up_queue/:applicantId/documents',
  },
  appeals: {
    index: '/appeals',
    details: {
      index: '/appeals/:appealId/details',
      committee: '/appeals/:appealId/committee/vote',
    },
  },
  reimbursements: {
    index: '/reimbursements',
    details: {
      index: '/reimbursements/:appealId/details',
    },
    request: {
      index: '/reimbursements/request',
    },
    review: {
      index: '/reimbursements/review',
    },
  },
  ledger: {
    index: '/ledger',
    global: {
      index: '/ledger/global',
    },
    reimbursements: {
      index: '/ledger/reimbursements',
    },
    reconciliation: {
      index: '/ledger/reconciliation',
    },
  },
  payments: {
    index: '/payments',
    details: {
      index: '/payments/:paymentId/details',
    },
  },
  transactions: {
    index: '/transactions',
    details: {
      index: '/transactions/:transactionId/details',
    },
  },
  providers: {
    index: '/providers',
    provider_details: {
      provider_info: '/providers/:providerId/details',
      store_config: '/providers/:providerId/store-configuration',
      transactions: '/providers/:providerId/transactions',
      marketplace: '/providers/:providerId/marketplace',
      add_product: '/providers/:providerId/add_product',
      edit_product: '/providers/:providerId/edit_product/',
      documents: '/providers/:providerId/documents',
      manage_users: '/providers/:providerId/manage_users',
      history: '/providers/:providerId/history',
      school_form: '/providers/:providerId/school_form',
    },
    new: {
      index: '/providers/new',
    },
    review: {
      index: '/providers/review',
    },
    selected: {
      index: '/providers/selected',
    },
  },
  scholarships: {
    index: '/scholarships',
    active_scholars: {
      index: '/scholarships/active_scholars',
    },
    notifications: {
      index: '/scholarships/scholar_notifications',
    },
    scholarship_details: {
      index: '/scholarships/:applicantId/details',
      applications: '/scholarships/:applicantId/applications',
      transactions: '/scholarships/:applicantId/transactions',
      appeals: '/scholarships/:applicantId/appeals',
      assesment: '/scholarships/:applicantId/assesment',
      history: '/scholarships/:applicantId/history',
    },
  },
  purse_settings: {
    index: '/purse_settings',
    id: '/purse_settings/:purseId',
  },
  setup: {
    index: '/setup',
    program: {
      index: '/setup/program',
    },
    help_links: {
      index: '/setup/link_handlers',
    },
    category_and_product_rules: {
      index: '/setup/category_and_product_rules',
    },

    systemCatalog: {
      index: '/setup/program_catalog',
    },
    users: {
      index: '/setup/users',
      details: '/setup/users/:userId/details',
      history: '/setup/users/:userId/history',
    },
    roles: {
      index: '/setup/roles',
    },
    global_items: {
      index: '/setup/global_items',
    },
    provider_categories: {
      index: '/setup/provider_categories',
    },
    provider_affiliations: {
      index: '/setup/provider_affiliations',
      manage_providers: '/setup/provider_affiliations/:affiliationId/providers',
    },
  },
  vendors: {
    index: '/vendors',
    details: {
      index: '/vendors/:vendorId',
    },
  },
  // reimbursements: {
  //   index: '/reimbursements',
  //   request: {
  //     index: '/reimbursements/request',
  //   },
  //   review: {
  //     index: '/reimbursements/review',
  //   },
  //   declined: {
  //     index: '/reimbursements/declined',
  //   },
  //   paid: {
  //     index: '/reimbursements/paid',
  //   },
  // },
  programs: {
    index: '/programs',
  },
  my_profile: {
    index: '/my_profile',
  },
} as const
